/**
 * Email validation regex pattern
 * Matches standard email format: local-part@domain.tld
 */
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

/**
 * Minimum password length requirement
 */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * Validates email format using standard email regex pattern
 * @param email - Email string to validate
 * @returns true if email matches valid format, false otherwise
 */
export const isValidEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};

/**
 * Validates password meets minimum length requirement
 * @param password - Password string to validate
 * @returns true if password is at least 8 characters, false otherwise
 */
export const isValidPassword = (password: string): boolean => {
  return password.length >= MIN_PASSWORD_LENGTH;
};

/**
 * Validation rules object for React Hook Form integration
 * Provides validation configuration for email and password fields
 */
export const validationRules = {
  email: {
    required: "Email is required",
    pattern: {
      value: EMAIL_REGEX,
      message: "Invalid email address"
    }
  },
  password: {
    required: "Password is required",
    minLength: {
      value: MIN_PASSWORD_LENGTH,
      message: `Password must be at least ${MIN_PASSWORD_LENGTH} characters`
    }
  }
};
